import { Button, Switch } from "@clockwise/design-system";
import { Settings as SettingsIcon } from "@clockwise/icons";
import { DropdownButton } from "@clockwise/web-commons/src/ui/dropdown-button/DropdownButton";
import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { electronAppVersion } from "@clockwise/web-commons/src/util/browser.util";
import React from "react";
import { useLocalStorage } from "usehooks-ts";

export const SHOW_MENU_BAR_MEETING_TITLE = "showMenuBarMeetingTitle";
export const MENU_BAR_TRUNCATE_LONG_TITLES = "menuBarTruncateLongTitles";

const ShowMenuBarMeetingTitle = () => {
  const track = useTracking();
  const [showMenuBarMeetingTitle, setShowMenuBarMeetingTitle] = useLocalStorage(
    SHOW_MENU_BAR_MEETING_TITLE,
    true,
  );

  const [menuBarTruncateLongTitles, setMenuBarTruncateLongTitles] = useLocalStorage(
    MENU_BAR_TRUNCATE_LONG_TITLES,
    false,
  );

  const handleChange = (checked: boolean) => {
    track(TrackingEvents.CLOCKWISE_MINI.PLANNER_MINI.SHOW_MENU_BAR_MEETING_TITLE, { checked });
    setShowMenuBarMeetingTitle(checked);
  };

  return (
    <div className="cw-flex cw-flex-col">
      <Switch
        checked={showMenuBarMeetingTitle}
        onChange={handleChange}
        label={<div>Show next meeting in menu bar</div>}
        labelPlacement="start"
        size="small"
      />
      <Switch
        checked={menuBarTruncateLongTitles}
        onChange={setMenuBarTruncateLongTitles}
        label={<div>Truncate long meeting names</div>}
        labelPlacement="start"
        size="small"
      />
    </div>
  );
};

// TODO next
// const NotifyOnMeetingStart = () => {
//   const track = useTracking();
//   const [notifyOnMeetingStart, setNotifyOnMeetingStart] = useLocalStorage(
//     "notifyOnMeetingStart",
//     true,
//   );

//   const handleChange = (checked: boolean) => {
//     track(TrackingEvents.CLOCKWISE_MINI.PLANNER_MINI.NOTIFY_ON_MEETING_START, { checked });
//     setNotifyOnMeetingStart(checked);
//   };

//   return (
//     <div>
//       <Switch
//         checked={notifyOnMeetingStart}
//         onChange={handleChange}
//         label={<div>Notify on meeting start</div>}
//         labelPlacement="start"
//         size="small"
//       />
//     </div>
//   );
// };

export const Settings = () => {
  const onQuit = () => {
    window.close();
  };
  const onReload = () => {
    window.location.reload();
  };

  return (
    <DropdownButton name="planner-settings" iconOpen={SettingsIcon} iconClosed={SettingsIcon}>
      <div className="cw-p-3 cw-flex cw-flex-col cw-space-y-2 cw-w-fit cw-items-end">
        <ShowMenuBarMeetingTitle />
        <div className="cw-flex cw-items-center cw-gap-3">
          {electronAppVersion && (
            <span className="cw-text-neutral cw-text-12">v{electronAppVersion}</span>
          )}
          <Button variant="outlined" sentiment="neutral" onClick={onReload}>
            Reload
          </Button>
          <Button variant="outlined" sentiment="neutral" onClick={onQuit}>
            Quit
          </Button>
        </div>
        {/* <NotifyOnMeetingStart /> */}
      </div>
    </DropdownButton>
  );
};
